<template>
    <div class="main-section">
        <div class="inner">
            <div class="main-section-head main-section-head--center">
                <h3 class="title title--large">Before <b>& After</b></h3>
            </div>
            <div class="main-section-body">
                <div class="compare-grid-container">
                    <div class="compare-grid" v-for="(portfolio, index) in portfolios" :key="index">
                        <div class="compare-grid__box">
                            <div class="compare-grid__images">
                                <div class="compare-slide">
                                    <!--
                                    ※ 썸네일 이미지 사이즈
                                    가로/세로 비율: 1.75
                                    Before, After 사진 사이즈 동일해야함.
                                -->

                                    <!-- 썸네일: Before -->
                                    <div v-if="portfolio.space.afterImage" class="image">
                                        <img class="thumb" :src="portfolio.space.afterImage" alt="" />
                                    </div>
                                    <!-- 썸네일: After -->
                                    <div v-if="portfolio.space.beforeImage" class="image image-overlay">
                                        <img class="thumb" :src="portfolio.space.beforeImage" alt="" />
                                    </div>
                                </div>
                            </div>
                            <router-link :to="getURL(portfolio)">
                                <div class="compare-grid__contents">
                                    <span class="compare-grid__title">{{ portfolio.subject }}</span>
                                    <ul class="compare-grid__tags">
                                        <li class="compare-grid__tag">{{ portfolio.category.name }}</li>
                                        <!-- <li class="compare-grid__tag">종합</li> -->
                                        <li class="compare-grid__tag">{{ (portfolio.construction.acreage || 0).format() }}평대</li>
                                        <li class="compare-grid__tag">{{ (portfolio.construction.discountPrice || portfolio.construction.supplyPrice || 0).format() }}만원대</li>
                                    </ul>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    data() {
        return {
            portfolios: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                var { portfolios } = await api.v1.portfolios.spaces.getSpaces({
                    headers: {
                        skip: 0,
                        limit: 8,
                    },
                    params: {
                        "space.beforeEnable": true,
                    },
                });
                this.portfolios = portfolios;

                this.$nextTick(() => {
                    this.compareSlider();
                });
            } catch (error) {
                console.error(error);
            }
        },
        compareSlider() {
            var x, i;
            x = document.getElementsByClassName("image-overlay");
            for (i = 0; i < x.length; i++) {
                compareImages(x[i]);
            }
            function compareImages(img) {
                var slider,
                    img,
                    clicked = 0,
                    w,
                    h;

                w = img.offsetWidth;
                h = img.offsetHeight;

                img.style.width = w / 2 + "px";

                slider = document.createElement("DIV");
                slider.setAttribute("class", "controller");

                img.parentElement.insertBefore(slider, img);

                slider.style.left = w / 2 - slider.offsetWidth / 2 + "px";

                slider.addEventListener("mousedown", slideReady);
                window.addEventListener("mouseup", slideFinish);
                slider.addEventListener("touchstart", slideReady, { passive: true });
                window.addEventListener("touchend", slideFinish);

                function slideReady(e) {
                    // e.preventDefault();
                    clicked = 1;

                    window.addEventListener("mousemove", slideMove);
                    window.addEventListener("touchmove", slideMove);
                }
                function slideFinish() {
                    clicked = 0;
                }
                function slideMove(e) {
                    var pos;

                    if (clicked == 0) return false;

                    pos = getCursorPos(e);

                    if (pos < 0) pos = 0;
                    if (pos > w) pos = w;

                    slide(pos);
                }
                function getCursorPos(e) {
                    var a,
                        x = 0;
                    e = e || window.event;
                    a = img.getBoundingClientRect();

                    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                        var touchX = 0;
                        for (i = 0; i < e.changedTouches.length; i++) {
                            touchX = e.changedTouches[i].pageX - a.left;
                            touchX = touchX - window.pageXOffset;
                        }
                        return touchX;
                    } else {
                        x = e.pageX - a.left;
                        x = x - window.pageXOffset;
                        return x;
                    }
                }
                function slide(x) {
                    img.style.width = x + "px";
                    slider.style.left = img.offsetWidth - slider.offsetWidth / 2 + "px";
                }
            }
        },
        getURL({ category, _id }) {
            const [code] = category?.code?.split("-") || [];
            const base = "/portfolio";
            if (code == "space1") return `${base}/resident/${_id}`;
            if (code == "space2") return `${base}/industry/${_id}`;
            if (code == "space3") return `${base}/partial/${_id}`;
        },
    },
};
</script>